export default {
  editedQueue: {},
};
